import { TooltipCommonProps } from '../common';
import { TooltipProps } from '../Tooltip';

export interface GooglePreviewProps {
  /** Applies a data-hook HTML attribute to be used in the tests */
  dataHook?: string;
  /** Sets a short description for the page */
  description?: string;
  /** Truncates description text at a specific number of lines */
  descriptionMaxLines?: number;
  /** Specifies an URL link to favicon source. If not provided, a fallback favicon will be displayed. */
  favicon?: string;
  /** Callback function triggered when description is clicked */
  onDescriptionClick?: React.MouseEventHandler<HTMLElement>;
  /** Defines a callback function which is called when cursor enters the description */
  onDescriptionMouseEnter?: React.MouseEventHandler<HTMLElement>;
  /** Defines a callback function which is called when cursor leaves the description */
  onDescriptionMouseLeave?: React.MouseEventHandler<HTMLElement>;
  /** Callback function triggered when title is clicked */
  onTitleClick?: React.MouseEventHandler<HTMLElement>;
  /** Defines a callback function which is called when cursor enters the title */
  onTitleMouseEnter?: React.MouseEventHandler<HTMLElement>;
  /** Defines a callback function which is called when cursor leaves the title */
  onTitleMouseLeave?: React.MouseEventHandler<HTMLElement>;
  /** Callback function triggered when website info section (favicon, site name and preview URL) is clicked */
  onWebsiteInfoClick?: React.MouseEventHandler<HTMLElement>;
  /** Sets the link for the site */
  previewUrl?: string;
  /** Sets the site name of the website */
  siteName?: string;
  /** Sets widget background color */
  skin?: 'light' | 'transparent';
  /** Sets the title of the page */
  title?: string;
  /** Truncates title text at a specific number of lines */
  titleMaxLines?: number;
  /** When provided, a tooltip will be displayed on website info section (favicon, site name and preview URL) hover */
  websiteInfoTooltipContent?: TooltipProps['content'];
  /** Allows to pass tooltip common props to website info tooltip.
   * @linkTypeTo components-overlays--tooltip
   * @setTypeName TooltipCommonProps
   */
  websiteInfoTooltipProps?: Partial<TooltipCommonProps>;
}
